import React from 'react';
import { motion } from 'framer-motion';
const problems = [{
  id: '01',
  title: 'Trabajas por proyecto, no por contrato.',
  description: 'Un negocio de Landscaping que solo cobra por corte no es escalable. El dinero real está en los contratos de mantenimiento mensual donde el cliente paga automáticamente todos los meses.'
}, {
  id: '02',
  title: 'Tu marketing atrae precio, no valor.',
  description: '"Corte de césped $45" atrae al cliente que cambiará de empresa si alguien le cobra $40. El Sistema A.C.E.™ atrae propietarios que pagan $500-$900/mes por un contrato de mantenimiento completo, sin regatear.'
}, {
  id: '03',
  title: 'No tienes presencia de autoridad local.',
  description: 'En Landscaping, el 70% de las decisiones se toman después de ver el trabajo en el jardín de un vecino o en Google. Si no apareces primero en Google Maps cuando buscan "Landscaping cerca de mí", ese contrato se lo lleva otro.'
}];
export function DiagnosisSection() {
  return <section className="py-24 px-6 bg-carbon-light border-y border-carbon-lighter" data-id="element-73">
      <div className="max-w-5xl mx-auto" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-75">
          <span className="text-gold font-heading font-semibold tracking-wider uppercase text-sm mb-3 block" data-id="element-76">
            El Diagnóstico
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white text-balance" data-id="element-77">
            El problema de fondo de los negocios de Landscaping.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-78">
          {problems.map((problem, index) => <motion.div key={problem.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-carbon border border-carbon-lighter p-8 rounded-2xl relative overflow-hidden group hover:border-gold/30 transition-colors duration-300" data-id="element-79">
              <div className="text-6xl font-heading font-extrabold text-carbon-lighter absolute -top-4 -right-2 select-none group-hover:text-carbon-light transition-colors duration-300" data-id="element-80">
                {problem.id}
              </div>

              <div className="relative z-10" data-id="element-81">
                <h3 className="font-heading text-xl font-bold text-white mb-4 leading-tight" data-id="element-82">
                  {problem.title}
                </h3>
                <p className="font-body text-neutral-400 leading-relaxed" data-id="element-83">
                  {problem.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}